import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { actionDoctor, actionPatient } from "../../../redux/actions";

import {
  PiBinoculars,
  PiCalendar,
  PiFolderOpen,
  PiTrash,
} from "react-icons/pi";
import { FiPhoneCall } from "react-icons/fi";
import { AppLayout } from "../../../layouts";
import {
  Badges,
  Header,
  Modaal,
  NavAndTabs,
  SearchBars,
  Sides,
  Tabbles,
} from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Commons } from "../../../utilities";
import { useAlert } from "../../../contexts";
import { ThreeDots } from "react-loader-spinner";

const AppointmentUpcoming = ({ loginData }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const options = [
    { value: 1, label: t("OnLine") },
    { value: 2, label: t("InClinic") },
    { value: 3, label: t("Chat") },
  ];
  const { id } = useParams();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(id || "my-appointments");
  const [appointmentUpcomingData, setAppointmentUpcomingData] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState("");
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedAppointmentGuid, setSelectedAppointmentGuid] = useState(null);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    dispatch(actionDoctor.getClinicDoctor(loginData.userGuid));
    dispatch(actionDoctor.getClinicDoctorDetails(loginData.clinicGuid));
  }, [dispatch, loginData.clinicGuid, loginData.userGuid]);

  useEffect(() => {
    setIsFetching(true);
    dispatch(actionPatient.clearAppointmentsData());
    const timeout = setTimeout(() => {
      if (activeTab === "my-appointments") {
        dispatch(
          actionPatient.getAppointments(
            10,
            1,
            "",
            "",
            "",
            "",
            loginData.userGuid,
            2,
            "",
            "",
            true,
            true,
            loginData?.currencyCode,
            loginData.timeZoneId,
            "",
            true,
            false,
            loginData?.languageId,
            null,
            null
          )
        ).finally(() => setIsFetching(false));
      } else if (activeTab === "clinic-appointments") {
        dispatch(
          actionPatient.getAppointments(
            10,
            1,
            "",
            "",
            "",
            "",
            "",
            2,
            "",
            "",
            true,
            true,
            loginData?.currencyCode,
            loginData.timeZoneId,
            loginData.clinicGuid,
            true,
            false,
            loginData?.languageId,
            null,
            null
          )
        ).finally(() => setIsFetching(false));
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [
    dispatch,
    activeTab,
    loginData.userGuid,
    loginData.clinicGuid,
    loginData.timeZoneId,
    loginData?.currencyCode,
    loginData?.languageId,
  ]);

  const getAppointmentsData = useSelector(
    (state) => state.patient.getAppointmentsData?.data
  );
  const loading = useSelector((state) => state.patient.loading);
  const getClinicDoctorData = useSelector(
    (state) => state.doctor.getClinicDoctorData?.data
  );
  const getClinicDoctorDetailsData = useSelector(
    (state) => state.doctor.getClinicDoctorDetailsData?.data
  );

  useEffect(() => {
    if (getAppointmentsData?.result?.patientAppointments) {
      setAppointmentUpcomingData(
        getAppointmentsData.result.patientAppointments
      );
    }
  }, [getAppointmentsData]);

  useEffect(() => {
    if (activeTab === "clinic-appointments") {
      if (getClinicDoctorDetailsData) {
        const doctorOptions =
          getClinicDoctorDetailsData?.result?.doctorLists?.map((item) => ({
            value: item.doctorGuid,
            label: item.doctorName,
          }));
        setOptions1(doctorOptions);
      }
    } else {
      if (getClinicDoctorData) {
        const newOption = getClinicDoctorData?.result?.map((item) => ({
          value: item.clinicGuid,
          label: item.clinicName,
        }));
        setOptions1(newOption);
      }
    }
  }, [activeTab, getClinicDoctorData, getClinicDoctorDetailsData]);

  const clinic = getClinicDoctorData?.result?.find(
    (item) => item.clinicGuid === loginData.clinicGuid
  );
  const clinicName = clinic ? clinic.clinicName : "";

  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };
  const handleChange = (type, value) => {
    switch (type) {
      case "search":
        setSearch(value);
        break;
      case "location":
        setSelectedLocation(value);
        break;
      case "clinic":
        setSelectedClinic(value);
        break;
      default:
        break;
    }
  };
  const startDate =
    appointmentUpcomingData?.length > 0
      ? Commons.formatDateWithOrdinal(
        new Date(appointmentUpcomingData[0].appointmentDateTime)
      )
      : "";

  const endDate =
    appointmentUpcomingData?.length > 0
      ? Commons.formatDateWithOrdinal(
        new Date(
          appointmentUpcomingData[
            appointmentUpcomingData.length - 1
          ].appointmentDateTime
        )
      )
      : "";
  const onTabChange = (tabId) => {
    setActiveTab(tabId);
    if (tabId === "clinic-appointments" && clinicName) {
      navigate(`/doctor/appointment-upcoming/${tabId}/${clinicName}`);
    } else {
      navigate(`/doctor/appointment-upcoming/${tabId}`);
      setDateRange([null, null]);
    }
    setDateRange([null, null]);
    setSelectedLocation([]);
    setSelectedClinic("");
    setSearch("");
  };
  const onSearchClick = (activeTab) => {
    let formattedFromDate = null;
    let formattedToDate = null;
    if (dateRange?.[0] && dateRange?.[1]) {
      const fromDate = new Date(
        dateRange[0].getTime() - dateRange[0].getTimezoneOffset() * 60000
      );
      const toDate = new Date(
        dateRange[1].getTime() - dateRange[1].getTimezoneOffset() * 60000
      );

      formattedFromDate = fromDate.toISOString().split(".")[0] + ".000";
      formattedToDate = toDate.toISOString().split(".")[0] + ".000";
    }

    let filteredAppointments;

    if (activeTab === "my-appointments") {
      setAppointmentUpcomingData(filteredAppointments);
    } else if (activeTab === "clinic-appointments") {
      const filteredAppointments = appointmentUpcomingData.filter(
        (appointment) => {
          const appointmentDate = new Date(appointment.appointmentDateTime);
          const isWithinDateRange =
            (!formattedFromDate ||
              appointmentDate >= new Date(formattedFromDate)) &&
            (!formattedToDate || appointmentDate <= new Date(formattedToDate));

          return isWithinDateRange;
        }
      );

      setAppointmentUpcomingData(filteredAppointments);
    }
  };
  const postBookedAppointment = (appointment, openModal) => {
    const credentials = {
      UserTimeZone: loginData.timeZoneId,
      UserCurrency: loginData?.currencyCode,
      appointmentGuid: appointment.appointmentGuid,
      LanguageId: loginData.languageId,
    };

    dispatch(
      actionPatient.postBookedAppointment(credentials, (error, response) => {
        if (error) {
          if (error.data) {
            if (error.data.statusCode === 400) {
              if (error.data.error && error.data.error.ValidationErrors) {
                error.data.error.ValidationErrors.forEach((validationError) => {
                  console.error(
                    `${t("Field")}: ${validationError.Field} - ${t(
                      "Message"
                    )}: ${validationError.Message}`
                  );

                  showAlert(
                    "danger",
                    validationError.Message,
                    `${t("Error")} : ${validationError.Field}`
                  );
                });
              } else {
                showAlert(
                  "danger",
                  t("Invalid_credentials"),
                  `${t("Error")} !`
                );
              }
            } else {
              showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
            }
          }
        } else if (response) {
          if (response.status === 200) {
            if (openModal) {
              setShowModal2(true);
            }
          }
        }
      })
    );
  };
  const tabs = [
    {
      id: "my-appointments",
      label: t("appointments.my_appointments"),
      content: (
        loading || isFetching ? (
          <div className="d-flex justify-content-center align-items-center"><ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#4fb1ad"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          /></div>
        ) : (
          <Tabbles.TableBlk
            headerIcon={<PiCalendar className="header-Icn" />}
            heading={t("appointments.upcoming.page-heading")}
            // subHeading="Today, 8th August 2024"

            subHeading={
              <span>
                {t("From")}, {startDate} - {endDate}
              </span>
            }
            columns={[
              `${t("patient_name")}`,
              `${t("clinics_name")}`,
              `${t("medical_specialty")}`,
              `${t("patient_details")}`,
              `${t("time_&_date")}`,
              `${t("location")}`,
              `${t("consult")}`,
              `${t("take_call")}`,
              `${t("decline")}`,
            ]}
            data={appointmentUpcomingData?.map((appointment) => ({
              [t("patient_name")]: (
                <div className="d-flex align-items-center">
                  <Badges.Badge1
                    text={appointment.externalUser ? "G" : "E"}
                    className={`ge-badge ${appointment.externalUser ? "g-badge" : "e-badge"
                      }`}
                  />{" "}
                  {appointment.patientFirstName +
                    " " +
                    appointment.patientLastName}
                </div>
              ),
              [t("clinics_name")]: appointment.clinicName,
              [t("medical_specialty")]: appointment.physicianServices,
              [t("patient_details")]: (
                <div className="editBlkIcon">
                  <PiFolderOpen
                    className="editIcon"
                    onClick={() => postBookedAppointment(appointment, true)}
                  />
                </div>
              ),
              [t("time_&_date")]: (
                <>
                  <div>
                    {new Date(appointment.appointmentDateTime).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      }
                    )}
                  </div>
                  <div>
                    {new Date(appointment.appointmentDateTime)
                      .toLocaleDateString("en-GB")
                      .replace(/\//g, " - ")}
                  </div>
                </>
              ),
              [t("location")]: appointment.appointmentType,
              [t("consult")]: (
                <Badges.Badge1
                  text={t("consult")}
                  className="consult-badge"
                  onClick={() =>
                    navigate(`/doctor/diagnostic-report/diagnostic-report`, {
                      state: {
                        appointment,
                        appointmentStatus: 2,
                      },
                    })
                  }
                />
              ),
              ...(appointment.appointmentStatus === "Approved" &&
                appointment.appointmentType === "Online"
                ? {
                  [t("take_call")]: (
                    <div className="editBlkIcon">
                      <FiPhoneCall
                        className="editIcon"
                        onClick={() => postBookedAppointment(appointment, true)}
                      />
                    </div>
                  ),
                }
                : {
                  [t("take_call")]: "-",
                }),

              [t("decline")]: (
                <PiTrash
                  className="delIcon noVerify"
                  onClick={() => {
                    postBookedAppointment(appointment, false);
                    setShowModal(true);
                    setSelectedAppointmentGuid(appointment.appointmentGuid);
                  }}
                />
              ),
            }))}
            tabbleClassname="tabble"
            noDataMessage={t("appointments.no_appointments_available")}
          />
        )
      ),
      disabled: false,
    },
    {
      id: "clinic-appointments",
      label: `${t("appointments.clinic_appointments")}(${clinicName})`,
      content: (
        loading || isFetching ? (
          <div className="d-flex justify-content-center align-items-center"><ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#4fb1ad"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          /></div>
        ) : (
          <Tabbles.TableBlk
            headerIcon={<PiCalendar className="header-Icn" />}
            heading={t("appointments.upcoming.page-heading")}
            subHeading={
              <span>
                {t("From")}, {startDate} - {endDate}
              </span>
            }
            columns={[
              `${t("patient_name")}`,
              `${t("doctor_name")}`,
              `${t("medical_specialty")}`,
              `${t("patient_details")}`,
              `${t("time_&_date")}`,
              `${t("location")}`,
              `${t("consult")}`,
              `${t("take_call")}`,
              `${t("decline")}`,
            ]}
            data={appointmentUpcomingData
              ?.filter((appointment) => appointment.iAppointmentStatus === 2)
              ?.map((appointment) => ({
                [t("patient_name")]: (
                  <div className="d-flex align-items-center">
                    <Badges.Badge1
                      text={appointment.externalUser ? "G" : "E"}
                      className={`ge-badge ${appointment.externalUser ? "g-badge" : "e-badge"
                        }`}
                    />{" "}
                    {appointment.patientFirstName +
                      " " +
                      appointment.patientLastName}
                  </div>
                ),
                [t("doctor_name")]:
                  appointment.doctorFirstName + " " + appointment.doctorLastName,
                [t("medical_specialty")]: appointment.physicianServices,
                [t("patient_details")]: (
                  <div className="editBlkIcon">
                    <PiFolderOpen
                      className="editIcon"
                      onClick={() => postBookedAppointment(appointment, true)}
                    />
                  </div>
                ),
                [t("time_&_date")]: (
                  <>
                    <div>
                      {new Date(
                        appointment.appointmentDateTime
                      ).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </div>
                    <div>
                      {new Date(appointment.appointmentDateTime)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, " - ")}
                    </div>
                  </>
                ),
                [t("location")]: appointment.appointmentType,
                [t("consult")]: (
                  <Badges.Badge1
                    text={t("consult")}
                    className="consult-badge"
                    onClick={() =>
                      navigate(`/doctor/diagnostic-report/diagnostic-report`, {
                        state: {
                          appointment,
                          appointmentStatus: 2,
                        },
                      })
                    }
                  />
                ),
                ...(appointment.appointmentStatus === "Approved" &&
                  appointment.appointmentType === "Online"
                  ? {
                    [t("take_call")]: (
                      <div className="editBlkIcon">
                        <FiPhoneCall
                          className="editIcon"
                          onClick={() =>
                            postBookedAppointment(appointment, true)
                          }
                        />
                      </div>
                    ),
                  }
                  : {
                    [t("take_call")]: "-",
                  }),
                [t("decline")]: (
                  <PiTrash
                    className="delIcon noVerify"
                    onClick={() => {
                      postBookedAppointment(appointment, false);
                      setShowModal(true);
                      setSelectedAppointmentGuid(appointment.appointmentGuid);
                    }}
                  />
                ),
              }))}
            tabbleClassname="tabble"
            noDataMessage={t("appointments.no_appointments_available")}
          />
        )
      ),
      disabled: false,
    },
  ];
  const rightSide = (
    <Container fluid className={`exado-container1`}>
      <Row className="exado-row1">
        <Col>
          <Header.HeadingPage
            pageHeading={
              activeTab === "clinic-appointments"
                ? `${t("appointments.upcoming.page-heading")} / ${clinicName}`
                : t("appointments.upcoming.page-heading")
            }
          />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <SearchBars.SearchBar
            className="search-bar"
            showDate={true}
            showSelect1={true}
            showSelect2={true}
            datepickermd={2}
            selectColmd1={3}
            selectColmd2={3}
            searchColmd={2}
            buttonColmd={2}
            datepickerxs={6}
            selectColxs1={6}
            selectColxs2={6}
            selectColxs={6}
            buttonColxs={12}
            searchGrpClassName="form-group1"
            select1Classname="select3"
            select2Classname="select3"
            select1Options={options}
            select2Options={options1}
            searchPlaceholder={t("Search")}
            select1Placeholder={t("location")}
            select2Placeholder={
              activeTab === "clinic-appointments"
                ? `${t("doctor.doctor")}`
                : `${t("Clinic")}`
            }
            cDateRangePlaceholder={t("enter") + " " + t("date")}
            cDateRangeClassname="custom-date-range-picker"
            buttonClassname="btn-solid-Aqua_Teal w-100"
            buttonChildren={<PiBinoculars className="bionCularIcon" />}
            dateRange={dateRange}
            searchValue={search}
            select1Value={selectedLocation}
            select2Value={selectedClinic}
            onDateRangeChange={handleDateRangeChange}
            onSearchClick={() => onSearchClick(activeTab)}
            onLocationChange={(selected) => handleChange("location", selected)}
            onClinicChange={(selected) => handleChange("clinic", selected)}
            onSearchChange={(e) => handleChange("search", e.target.value)}
          />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <NavAndTabs.NavAndTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
        </Col>
      </Row>
    </Container>
  );
  return (
    <>
      <AppLayout.AppLayoutOne
        leftSide={<Sides.LeftSides loginData={loginData} />}
        rightSide={rightSide}
      />
      <Modaal.PatientDetailsModal
        show={showModal2}
        onHide={() => setShowModal2(false)}
        loginData={loginData}
        setShowModal3={setShowModal}
        setShowModal2={setShowModal2}
        setSelectedAppointmentGuid={setSelectedAppointmentGuid}
      />
      <Modaal.CancelAppointmentModal
        show={showModal}
        onHide={() => setShowModal(false)}
        loginData={loginData}
        appointmentGuid={selectedAppointmentGuid}
        setSelectedAppointmentGuid={setSelectedAppointmentGuid}
      />
    </>
  );
};

export default AppointmentUpcoming;
